// extracted by mini-css-extract-plugin
export default {"header":"lgbSUQegsxZda5ZYcxqO","backButton":"oscjmDPSf62LwvJptZWj","title":"z9ZhKm94AqlwFI4l0cEU"};